var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotLiked(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    fill: "#555555"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.273 19.5478L12.2722 19.5472C10.2336 17.6986 8.58176 16.1977 7.43372 14.7931C6.29117 13.3953 5.7 12.1541 5.7 10.8333C5.7 8.67553 7.38221 7 9.53333 7C10.7531 7 11.9321 7.57041 12.6994 8.46443L13.0788 8.9065L13.4582 8.46443C14.2255 7.57041 15.4045 7 16.6242 7C18.7754 7 20.4576 8.67553 20.4576 10.8333C20.4576 12.1541 19.8664 13.3953 18.7238 14.7931C17.5758 16.1977 15.924 17.6986 13.8853 19.5472L13.8846 19.5478L13.0788 20.2814L12.273 19.5478Z",
    stroke: "#22FF60"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotLiked);
export default __webpack_public_path__ + "static/media/NotLiked.2925e61abafd0d5342fb8916e18ccfe4.svg";
export { ForwardRef as ReactComponent };